module.exports = __webpack_public_path__ + "static/media/banked-custom-choice.bf4a3914.png";